module.exports = __webpack_public_path__ + "img/w20.1f5fdda8.svg";